export default __webpack_public_path__ + "static/studiostrack-logo-mobile-ca8c04566c072b33d27b15dbdba2540b.svg";